import { defineMessages, useIntl } from 'react-intl';

import { useClientProps } from '../ProfileMenu/providers/ClientPropsProvider';

import { EntityPickerFullScreen } from './components/EntityPickerFullScreen';
import { OrgSwitcherFallback } from './components/OrgSwitcherFallback';
import { useResourceContext } from './hooks/useResourceContext';
import { OrgSwitcher } from './OrgSwitcher';

const messages = defineMessages({
  resourceCaption: {
    id: 'OrgSwitcher.resourceCaption',
    defaultMessage: 'Entities ({count})',
    description: 'Caption for the resource count in the org switcher',
  },
});

export function OrgSwitcherContainer() {
  const { formatMessage } = useIntl();
  const { redesignEnabled } = useClientProps();
  const {
    resources,
    activeResourceId,
    handleResourceSwitch,
    activeResource,
    needsSelection,
    handleBlockingSelection,
  } = useResourceContext();

  // Show full-screen entity picker when user must choose
  if (needsSelection && resources && resources.length > 1) {
    return (
      <>
        <OrgSwitcherFallback />
        <EntityPickerFullScreen resources={resources} onSelect={handleBlockingSelection} />
      </>
    );
  }

  // Hide for a single user-type resource (no org switching needed)
  if (resources?.length === 1 && resources[0].resourceType === 'user') {
    return null;
  }

  // Hide when there are no resources
  if (!resources || resources.length === 0) {
    return null;
  }

  // Single legal_entity and 2+ resources are passed through to the dumb OrgSwitcher
  const searchCountLabel = formatMessage(messages.resourceCaption, { count: resources.length });

  return (
    <OrgSwitcher
      resources={resources}
      activeResource={activeResource}
      activeResourceId={activeResourceId}
      onResourceSwitch={handleResourceSwitch}
      searchCountLabel={searchCountLabel}
      redesignEnabled={redesignEnabled}
    />
  );
}
